import { ArrowLeft, Compass } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PageMeta } from '../components/PageMeta'

export default function NotFoundPage() {
  return (
    <section className="not-found-page">
      <PageMeta title="Page not found" description="The page you requested could not be found." path="/page-not-found" noIndex />
      <div className="not-found-orbit" aria-hidden="true"><span /><Compass /></div>
      <span className="eyebrow">404 · A wrong turn</span>
      <h1>This page wandered off.</h1>
      <p>The health hub is still right here. Head home or explore the latest patient guides.</p>
      <div><Link className="button" to="/"><ArrowLeft size={17} /> Back home</Link><Link className="button button-ghost" to="/insights">Browse insights</Link></div>
    </section>
  )
}
